import Evaluation from 'models/Evaluation';
import EvaluationSubmission from 'models/EvaluationSubmission';

export default class EvaluationGradebook {
  public assigned: Evaluation[];
  public submissions: Record<string, EvaluationSubmission[]>;

  constructor(
    assigned: Evaluation[],
    submissions: Record<string, EvaluationSubmission[]>,
  ) {
    this.assigned = assigned.sort(
      (e1, e2) =>
        new Date(e2.created_at).getTime() - new Date(e1.created_at).getTime(),
    );
    this.submissions = submissions;
  }

  static fromEvaluationGradebook(evaluationGradebook: EvaluationGradebook) {
    return new EvaluationGradebook(
      evaluationGradebook.assigned.slice(),
      evaluationGradebook.submissions,
    );
  }

  static fromServerEvaluations(
    serverEvaluations: Record<string, any>,
  ): EvaluationGradebook {
    return new EvaluationGradebook(
      serverEvaluations.assigned,
      serverEvaluations.submissions,
    );
  }

  public toJSON(): Record<string, any> {
    return { ...this };
  }
}
